export default __webpack_public_path__ + "static/media/sextopy_logo.adb33a11.svg";